import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';
import { getItemFromRefList } from '../../../../main/reducers/static/states/referenceLists/reducer';

const INIT_STATE = 'INIT_STATE';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_GET_AUTH_ACCOUNT_DATA_REQUEST = 'SEND_GET_AUTH_ACCOUNT_DATA_REQUEST';
const UPDATE_AUTH_ACCOUNT_DATA = 'UPDATE_AUTH_ACCOUNT_DATA';
const CHANGE_HAS_AUTHORIZED = 'CHANGE_HAS_AUTHORIZED';

const reducerDotPath = `usersModule.states.authAccount`;
const createActionName = name => `app/${reducerDotPath}/${name}`;

const createReducer = () => {
  function stateDefault() {
    return {
      ...createRequestState(),
      hasAuthorized: null,
      authAccountData: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(SEND_GET_AUTH_ACCOUNT_DATA_REQUEST):
        return setRequestStateInProgress(state);
      case createActionName(UPDATE_AUTH_ACCOUNT_DATA):
        return state.merge({ authAccountData: action.payload || {} });
      case createActionName(CHANGE_HAS_AUTHORIZED):
        return state.merge({
          hasAuthorized: action.payload.hasAuthorized
        });
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

export const initState = () => ({
  type: createActionName(INIT_STATE)
});
export const requestFinished = (codeResponse, hasSuccess) => ({
  type: createActionName(REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendGetAuthAccountDataRequest = () => ({
  type: createActionName(SEND_GET_AUTH_ACCOUNT_DATA_REQUEST)
});
export const updateAuthAccountData = payload => ({
  type: createActionName(UPDATE_AUTH_ACCOUNT_DATA),
  payload
});
export const changeHasAuthorized = hasAuthorized => ({
  type: createActionName(CHANGE_HAS_AUTHORIZED),
  payload: { hasAuthorized }
});

export const getState = state => _.get(state, reducerDotPath);
export const selectRequestState = state =>
  _.get(getState(state), 'requestState');

export const selectAuthAccountData = state =>
  _.get(getState(state), 'authAccountData');

export const selectHasAuthorized = state =>
  _.get(getState(state), 'hasAuthorized');

export const selectUserId = state => getState(state).authAccountData.userId;
export const selectUserName = state => getState(state).authAccountData.username;
export const selectFullName = state => getState(state).authAccountData.fullName;
export const selectAvatarPath = state =>
  getState(state).authAccountData.avatarPath;
export const selectBirthDt = state => getState(state).authAccountData.birthDt;
export const selectBirthDtYearsOld = state =>
  getState(state).authAccountData.birthDtYearsOld;

export const selectGender = state => getState(state).authAccountData.gender;
export const selectGenderLabel = state => {
  const gender = getState(state).authAccountData.gender;
  if (gender) {
    return getItemFromRefList(state, 'userGanders').find(
      obj => obj.id === gender
    );
  }
  return undefined;
};

export const selectCreatedAt = state =>
  getState(state).authAccountData.createdAt;
export const selectLastAuthAt = state =>
  getState(state).authAccountData.lastAuthAt;
export const selectRating = state => getState(state).authAccountData.rating;
export const selectEmail = state => getState(state).authAccountData.email;
export const selectLocation = state => getState(state).authAccountData.location;
export const selectReferrer = state => getState(state).authAccountData.referrer;
export const selectConcatRoles = state =>
  getState(state).authAccountData.concatRoles;
export const selectTasksCountStat = state =>
  getState(state).authAccountData.countsStat.tasksStat;
export const selectCommentsInCountStat = state =>
  getState(state).authAccountData.countsStat.commentsIn;
export const selectCommentsOutCountStat = state =>
  getState(state).authAccountData.countsStat.commentsOut;
export const selectReferralsCountStat = state =>
  getState(state).authAccountData.countsStat.referrals;



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/states/authAccount.js